import React, { Suspense } from "react";
import { useTranslation } from "react-i18next";

import { HvDialog } from "@hitachivantara/uikit-react-core";

import DialogContent, { SopStepDialogContentProps } from "./DialogContent";

import useStyles from "./styles";

interface SopStepDialogProps extends Partial<SopStepDialogContentProps> {
  isOpen: boolean;
  onClose: () => void;
}

const SopStepDialog: React.FC<SopStepDialogProps> = ({
  isOpen,
  onClose,
  sopId,
  stepIndex,
  ...others
}) => {
  const onCloseHandler = (
    _event: unknown,
    reason: "backdropClick" | "escapeKeyDown"
  ) => {
    if (reason !== "backdropClick") {
      onClose?.();
    }
  };

  const classes = useStyles();
  const { t } = useTranslation("sopStepDialog");

  return (
    <HvDialog
      buttonTitle={t("close")}
      classes={{ paper: classes.paper }}
      open={isOpen}
      onClose={onCloseHandler}
      fullWidth
      maxWidth="md"
    >
      <Suspense fallback={<></>}>
        {isOpen && sopId != null && stepIndex != null && (
          // this separation is merely for enclosing the api calls in the dialog's <Suspense>, rather than the page's
          <DialogContent
            key={sopId}
            sopId={sopId}
            stepIndex={stepIndex}
            {...others}
          />
        )}
      </Suspense>
    </HvDialog>
  );
};

export default SopStepDialog;
